import toast from 'react-hot-toast';

const TOAST_ID = 'hv-tracker-toast';
const BORDER = '1px solid color-mix(in srgb, var(--text-inverse) 24%, transparent)';

const SEVERITY_STYLES = {
  success: {
    background: 'var(--success)',
    color: 'var(--text-inverse)',
    border: BORDER,
  },
  error: {
    background: 'var(--error)',
    color: 'var(--text-inverse)',
    border: BORDER,
  },
  warning: {
    background: 'var(--warning)',
    color: 'var(--text-inverse)',
    border: BORDER,
  },
  info: {
    background: 'var(--info)',
    color: 'var(--text-inverse)',
    border: BORDER,
  },
};

const BASE_STYLE = {
  borderRadius: 'var(--radius-sm)',
  fontSize: '0.875rem',
  fontWeight: 500,
  boxShadow: 'var(--tracker-snackbar-shadow, var(--shadow-lg))',
  maxWidth: 480,
  whiteSpace: 'pre-wrap',
};

const ICON_THEME = {
  primary: 'var(--text-inverse)',
  secondary: 'transparent',
};

function durationFor(type) {
  return type === 'warning' ? 7000 : 4000;
}

function show(message, type = 'info', options = {}) {
  const severity = SEVERITY_STYLES[type] ? type : 'info';
  const style = {
    ...BASE_STYLE,
    ...SEVERITY_STYLES[severity],
    ...options.style,
  };
  const restOptions = { ...options };
  delete restOptions.id;
  delete restOptions.style;
  const toastOptions = {
    id: TOAST_ID,
    position: 'top-center',
    duration: options.duration ?? durationFor(severity),
    style,
    iconTheme: ICON_THEME,
    ...restOptions,
    id: TOAST_ID,
    style,
  };

  toast.remove();
  if (severity === 'success') return toast.success(message, toastOptions);
  if (severity === 'error') return toast.error(message, toastOptions);
  return toast(message, toastOptions);
}

export const trackerToast = {
  show,
  success: (message, options) => show(message, 'success', options),
  error: (message, options) => show(message, 'error', options),
  warning: (message, options) => show(message, 'warning', options),
  info: (message, options) => show(message, 'info', options),
  dismiss: () => toast.remove(),
};
